import ConfirmationPopup from '@Components/Popups/ConfirmationPopup'
import React from 'react'
import Popup from '@Components/Popups/Popup'

export interface BulkDocumentUploadConfirmationPopupProps {
    onClose: () => void
}

const BulkDocumentUploadConfirmationPopup = (props: BulkDocumentUploadConfirmationPopupProps) => {
    const { onClose } = props
    return (
        <Popup onClose={onClose}>
            <ConfirmationPopup title="Documents Submitted" onConfirm={onClose} confirmButtonText="Done">
                <span>Your documents have been submitted for review.</span>
            </ConfirmationPopup>
        </Popup>
    )
}
export default BulkDocumentUploadConfirmationPopup
